import { Button, makeStyles } from "@material-ui/core"
import { AlertTitle } from "@material-ui/lab"
import Alert from "@material-ui/lab/Alert"
import { useContext } from "react"
import useEndereco from "../../../contexts/EnderecoContext"
import SiteContext from "../../../contexts/SiteContext"
import { useTextos } from "../../../contexts/TextosContext"
import useCustomHistory from "../../../hooks/useCustomHistory"
import { formatarParaDinheiro } from "../../../services/functions"

const useStyles = makeStyles({
    alert: {
        margin: "0.5rem 0",
        "& .MuiAlert-icon": {
            alignItems: "center",
        },
    },
})

function AlertaSemEntrega(props = { compact: false }) {
    const {
        enderecoAtual,
        isDelivery,
        entregaNoEndereco,
        iniciarCadastroEndereco,
        estabelecimentosQueEntregam,
    } = useEndereco()
    const textos = useTextos()
    const classes = useStyles()

    if (!isDelivery || entregaNoEndereco || estabelecimentosQueEntregam.length) return null

    return (
        <Alert
            severity="error"
            className={classes.alert}
            action={<Button onClick={iniciarCadastroEndereco}>{textos.alterar}</Button>}
        >
            <AlertTitle>{textos.naoEntregaEndereco}</AlertTitle>
            {props.compact ? null : enderecoAtual.logradouro}, {enderecoAtual.numero} -{" "}
            {enderecoAtual.bairro}
        </Alert>
    )
}

function AlertaOutroEstabelecimentoEntrega(props = { compact: false }) {
    const { isDelivery, entregaNoEndereco, estabelecimentosQueEntregam } = useEndereco()
    const history = useCustomHistory()
    const textos = useTextos()
    const classes = useStyles()

    if (!isDelivery || entregaNoEndereco || !estabelecimentosQueEntregam.length) return null

    return (
        <Alert
            severity="info"
            className={classes.alert}
            action={<Button onClick={() => history.push("/lojas")}>{textos.alterar}</Button>}
        >
            <AlertTitle>{textos.existeOutroEstabelecimento}</AlertTitle>
            {props.compact ? null : estabelecimentosQueEntregam.map(e => e.nome)}
        </Alert>
    )
}

function AlertaMinimoEntregaGratis() {
    const { minimoEntregaGratis, entregaNoEndereco, isFreteGratisMinimoEntrega, isDelivery } =
        useEndereco()
    const textos = useTextos()
    const classes = useStyles()

    if (!isDelivery || !entregaNoEndereco || !minimoEntregaGratis) return null

    return (
        <Alert
            severity={isFreteGratisMinimoEntrega ? "success" : "warning"}
            className={classes.alert}
        >
            {textos.alertas.freteGratisAcima}{" "}
            <span className="bold">{formatarParaDinheiro(minimoEntregaGratis)}</span>{" "}
            {textos.alertas.noTotalProdutos}.
        </Alert>
    )
}

function AlertaMinimoRetirada() {
    const { isRetiradaNoLocal, minimoRetiradaNoLocal, isMinimoRetiradaNoLocal } = useEndereco()
    const textos = useTextos()
    const classes = useStyles()

    if (!isRetiradaNoLocal || !minimoRetiradaNoLocal) return null

    return (
        <Alert className={classes.alert} severity={isMinimoRetiradaNoLocal ? "success" : "warning"}>
            {textos.alertas.valorMinimoRetirada}{" "}
            <span className="bold">{formatarParaDinheiro(minimoRetiradaNoLocal)}</span>
        </Alert>
    )
}

function AlertaMinimoCupom() {
    const { carrinho } = useContext(SiteContext)
    const textos = useTextos()
    const classes = useStyles()

    if (!carrinho.cupomDesconto) return null

    return (
        <Alert
            severity={
                carrinho.pedido.valorTotal > carrinho.cupomDesconto.valorPedidoMinimo
                    ? "success"
                    : "warning"
            }
            className={classes.alert}
        >
            {textos.alertas.valorMinimoCupom}{" "}
            <span className="bold">{carrinho.cupomDesconto.codigoCupom}</span>:{" "}
            <span className="bold">
                {formatarParaDinheiro(carrinho.cupomDesconto.valorPedidoMinimo)}
            </span>
        </Alert>
    )
}

export {
    AlertaMinimoCupom,
    AlertaMinimoEntregaGratis,
    AlertaMinimoRetirada,
    AlertaOutroEstabelecimentoEntrega,
    AlertaSemEntrega,
}
